import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'react-redux';
import type { ProviderCommonHeaderState } from './types';

export const getProviderHeaderInfo = (state: RootState) => state.providerCommonHeader;

export const selectProviderHeaderInfo = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.data;
  },
);

export const selectRtCond = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.rtCond;
  },
);

export const selectRtCondEx = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.rtCondEx;
  },
);

export const selectIsFetchingProviderHeaderInfo = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => state.isFetching,
);

export const selectIsBookmarked = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.isBookmarked;
  },
);

export const selectIsBookmarkStatusFetched = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.isBookmarkStatusFetched;
  },
);

export const selectIsBookmarkError = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.isBookmarkError;
  },
);

export const selectIsBookmarkLimitError = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.isBookmarkLimitError;
  },
);

export const selectBookmarkErrorId = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.bookmarkErrorId;
  },
);

export const selectIsJRDP = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.isJRDP;
  },
);

export const selectJrdpQuery = createSelector(
  getProviderHeaderInfo,
  (state: ProviderCommonHeaderState) => {
    return state.jrdpQuery;
  },
);
